import { Component, input } from '@angular/core';

/**
 * State Status Indicators Component
 *
 * Reusable component for displaying state status with visual indicators.
 * Shows initialized, loading, ready, and hasData status with colored dots.
 *
 * @example
 * <app-state-status-indicators
 *   [initialized]="state.initialized()"
 *   [loading]="state.loading()"
 *   [isReady]="state.isReady()"
 *   [hasData]="state.hasData()"
 *   [error]="state.error()"
 * />
 */
@Component({
  selector: 'app-state-status-indicators',
  templateUrl: './state-status-indicators.component.html',
  styleUrls: ['./state-status-indicators.component.scss'],
  standalone: true,
})
export class StateStatusIndicatorsComponent {
  // State status inputs
  readonly initialized = input.required<boolean>();
  readonly loading = input.required<boolean>();
  readonly isReady = input.required<boolean>();
  readonly hasData = input.required<boolean>();
  readonly error = input<string | null>(null);
  
  // Optional additional status
  readonly hasActiveTeam = input<boolean>(false);
}
